import { DashboardAnalyticsDTO } from "./dashboard.dto";
import { DashboardAnalyticsResponse } from "./dashboard.model";

export function mapDashboardAnalyticsDto(
  dto: DashboardAnalyticsDTO,
): DashboardAnalyticsResponse {
  return {
    propertiesCount: dto.properties_count,
    viewsTotal: dto.screenings_total,
    favoritesCount: dto.favorites_count,
  };
}
